"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Inner = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'block',
  padding: theme.spacing(4, 0),
  background: theme.palette.grey[50],
  [theme.breakpoints.up('lg')]: {
    background: 'transparent',
    padding: theme.spacing(1, 0)
  }
}));
const Inner = exports.Inner = (0, _mui.styled)('div')(({
  theme
}) => ({
  gridRow: '1 / 2',
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 40px)',
  justifyContent: 'center',
  gap: theme.spacing(2),
  [theme.breakpoints.up('lg')]: {
    padding: 0
  }
}));
